import c from './expandable-link-card.module.scss';
import ExpandableCard from '../../../common/expandable-card/ExpandableCard';
import { LINK_STATUS } from '../constants';
import classNames from 'classnames';
import { fontStyles } from '@monash/portal-react';
import { memo } from 'react';

const ExpandableLinkCard = ({
  link,
  openSlideForm,
  handleCheck,
  ...restProps
}) => {
  const description = link.description;
  const categories = link.categories;
  const isScheduled = link.status === LINK_STATUS.SCHEDULED;

  return (
    <ExpandableCard
      title={link.name}
      label={link.url}
      status={link.status}
      publishDate={isScheduled && link.startDate}
      hasCheckbox
      onClick={() => {
        openSlideForm(link);
      }}
      handleCheck={(e) => handleCheck(link?.id, e)}
      expandedContent={
        <div className={c.collapsibleContent}>
          <div className={c.section}>
            <div className={classNames(fontStyles.label, c.label)}>
              Description
            </div>
            <div>{description}</div>
          </div>
          {Array.isArray(categories) && categories.length > 0 && (
            <div className={c.section}>
              <div className={classNames(fontStyles.label, c.label)}>
                Categories
              </div>
              {categories?.map((category) => {
                return <div key={category}>{category.title}</div>;
              })}
            </div>
          )}
        </div>
      }
      {...restProps}
    />
  );
};

export default memo(ExpandableLinkCard);
